export default {
  path: 'category',
  name: 'CategoryList',
  component: () => import(/* webpackChunkName: "category-list" */ '@/pages/category/CategoryList'),
  meta: {title:'分类管理'}
}
